import React from 'react';
import Image from '@/components/AppImage/AppImage';

interface SVGGoogleLogoProps {
  className?: string;
  /** Rendered width in px; height scales proportionally (74×24 natural ratio). */
  width?: number;
}

const SVGGoogleLogo: React.FC<SVGGoogleLogoProps> = ({ className, width = 48 }) => (
  <Image
    src="/images/google_wordmark.svg"
    alt="Google"
    width={width}
    height={Math.round((width / 74) * 24)}
    className={className}
    style={{ objectFit: 'contain' }}
    unoptimized
  />
);

export default SVGGoogleLogo;
